module.exports = __webpack_public_path__ + "img/window-S.b7c8c83c.svg";